export let layout = {
    1:[{
        region:{

                    area:{
                        height: "1",
                        left: "0",
                        top: "0",
                        width: "1"
                     },
                     id: "1",
                     shape: "rectangle"

        }
    }
     ],
    2:[
        {
            region:{
            area: {
                height: "1/2",
                left: "0",
                top: "1/4",
                width: "1/2"
            },
            id: "1",
            shape: "rectangle"
        }
    },{

            region: {
                area: {
                    height: "1/2",
                    left: "1/2",
                    top: "1/4",
                    width: "1/2"
                },
                id: "2",
                shape: "rectangle"
            }
    }],
    3:[{

            region: {
                area: {
                    left: "1/4",
                    top: "0",
                    width: "1/2",
                    height: "1/2"
                },
                id: "1",
                shape: "rectangle"
            }
    },{
            region: {
                area: {
                    left: "0",
                    top: "1/2",
                    width: "1/2",
                    height: "1/2"
                },
                id: "2",
                shape: "rectangle"
            }
    },{
            region:{ area:{
                left: "1/2",
                top: "1/2",
                width: "1/2",
                height: "1/2"
            },
            id: "3",
            shape: "rectangle"
            }
    }
    ],
    4:[{
        region: {
            area: {
                left: '0',
                top: '0',
                width: '1/2',
                height: '1/2'
            },
            id: "1",
            shape: "rectangle"
        }
    },{
        region: {
            area: {
                left: '1/2',
                top: '0',
                width: '1/2',
                height: '1/2'
            },
            id: "2",
            shape: "rectangle"
        }
    },{
            region: {
                area: {
                    left: '0',
                    top: '1/2',
                    width: '1/2',
                    height: '1/2'
                },
                id: "3",
                shape: "rectangle"
            }
    },{

        region: {
            area: {
                left: '1/2',
                top: '1/2',
                width: '1/2',
                height: '1/2'
            },
            id: "4",
            shape: "rectangle"
        }
    }],
    5:[{

        region: {
            area: {
                left: '0',
                top: '0',
                width: '1/3',
                height: '1/3'
            },
            id: "1",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/3',
                top: '0',
                width: '1/3',
                height: '1/3'
            },
            id: "2",
            shape: "rectangle"
        }
    },{


        region: {
            area: {
                left: '2/3',
                top: '0',
                width: '1/3',
                height: '1/3'
            },
            id: "3",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '1/3',
                width: '1/2',
                height: '2/3'
            },
            id: "4",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/2',
                top: '1/3',
                width: '1/2',
                height: '2/3'
            },
            id: "5",
            shape: "rectangle"
        }
    }],
    6:[{

        region: {
            area: {
                left: '0',
                top: '0',
                width: '2/3',
                height: '2/3'
            },
            id: "1",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '2/3',
                top: '0',
                width: '1/3',
                height: '1/3'
            },
            id: "2",
            shape: "rectangle"
        }
    },{


        region: {
            area: {
                left: '2/3',
                top: '1/3',
                width: '1/3',
                height: '1/3'
            },
            id: "3",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '2/3',
                width: '1/3',
                height: '1/3'
            },
            id: "4",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/3',
                top: '2/3',
                width: '1/3',
                height: '1/3'
            },
            id: "5",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '2/3',
                top: '2/3',
                width: '1/3',
                height: '1/3'
            },
            id: "6",
            shape: "rectangle"
        }
    }],
    7:[{

        region: {
            area: {
                left: '1/6',
                top: '0',
                width: '1/3',
                height: '1/3'
            },
            id: "1",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/2',
                top: '0',
                width: '1/3',
                height: '1/3'
            },
            id: "2",
            shape: "rectangle"
        }
    },{


        region: {
            area: {
                left: '1/6',
                top: '1/3',
                width: '1/3',
                height: '1/3'
            },
            id: "3",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/2',
                top: '1/3',
                width: '1/3',
                height: '1/3'
            },
            id: "4",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '2/3',
                width: '1/3',
                height: '1/3'
            },
            id: "5",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/3',
                top: '2/3',
                width: '1/3',
                height: '1/3'
            },
            id: "6",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '2/3',
                top: '2/3',
                width: '1/3',
                height: '1/3'
            },
            id: "7",
            shape: "rectangle"
        }
    }],
    8:[{

        region: {
            area: {
                left: '0',
                top: '0',
                width: '3/4',
                height: '3/4'
            },
            id: "1",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '0',
                width: '1/4',
                height: '1/4'
            },
            id: "2",
            shape: "rectangle"
        }
    },{


        region: {
            area: {
                left: '3/4',
                top: '1/4',
                width: '1/4',
                height: '1/4'
            },
            id: "3",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '1/2',
                width: '1/4',
                height: '1/4'
            },
            id: "4",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "5",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/4',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "6",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/2',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "7",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "8",
            shape: "rectangle"
        }
    }],
    9:[{

        region: {
            area: {
                left: '0',
                top: '0',
                width: '1/3',
                height: '1/3'
            },
            id: "1",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/3',
                top: '0',
                width: '1/3',
                height: '1/3'
            },
            id: "2",
            shape: "rectangle"
        }
    },{


        region: {
            area: {
                left: '2/3',
                top: '0',
                width: '1/3',
                height: '1/3'
            },
            id: "3",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '1/3',
                width: '1/3',
                height: '1/3'
            },
            id: "4",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/3',
                top: '1/3',
                width: '1/3',
                height: '1/3'
            },
            id: "5",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '2/3',
                top: '1/3',
                width: '1/3',
                height: '1/3'
            },
            id: "6",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '2/3',
                width: '1/3',
                height: '1/3'
            },
            id: "7",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/3',
                top: '2/3',
                width: '1/3',
                height: '1/3'
            },
            id: "8",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '2/3',
                top: '2/3',
                width: '1/3',
                height: '1/3'
            },
            id: "9",
            shape: "rectangle"
        }
    }],
    10:[
        {

        region: {
            area: {
                left: '0',
                top: '0',
                width: '1/2',
                height: '1/2'
            },
            id: "1",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/2',
                top: '0',
                width: '1/2',
                height: '1/2'
            },
            id: "2",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '1/2',
                width: '1/4',
                height: '1/4'
            },
            id: "3",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/4',
                top: '1/2',
                width: '1/4',
                height: '1/4'
            },
            id: "4",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/2',
                top: '1/2',
                width: '1/4',
                height: '1/4'
            },
            id: "5",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '1/2',
                width: '1/4',
                height: '1/4'
            },
            id: "6",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "7",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/4',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "8",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/2',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "9",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "10",
            shape: "rectangle"
        }
    }],
    11:[
        {

        region: {
            area: {
                left: '1/8',
                top: '0',
                width: '1/4',
                height: '1/3'
            },
            id: "1",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/8',
                top: '0',
                width: '1/4',
                height: '1/3'
            },
            id: "2",
            shape: "rectangle"
        }
    },{


        region: {
            area: {
                left: '5/8',
                top: '0',
                width: '1/4',
                height: '1/3'
            },
            id: "3",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '1/3',
                width: '1/4',
                height: '1/3'
            },
            id: "4",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/4',
                top: '1/3',
                width: '1/4',
                height: '1/3'
            },
            id: "5",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/2',
                top: '1/3',
                width: '1/4',
                height: '1/3'
            },
            id: "6",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '1/3',
                width: '1/4',
                height: '1/3'
            },
            id: "7",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '2/3',
                width: '1/4',
                height: '1/3'
            },
            id: "8",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/4',
                top: '2/3',
                width: '1/4',
                height: '1/3'
            },
            id: "9",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/2',
                top: '2/3',
                width: '1/4',
                height: '1/3'
            },
            id: "10",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '2/3',
                width: '1/4',
                height: '1/3'
            },
            id: "11",
            shape: "rectangle"
        }
    }],
    12:[
        {

        region: {
            area: {
                left: '0',
                top: '0',
                width: '1/4',
                height: '1/3'
            },
            id: "1",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/4',
                top: '0',
                width: '1/4',
                height: '1/3'
            },
            id: "2",
            shape: "rectangle"
        }
    },{


        region: {
            area: {
                left: '1/2',
                top: '0',
                width: '1/4',
                height: '1/3'
            },
            id: "3",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '0',
                width: '1/4',
                height: '1/3'
            },
            id: "4",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '1/3',
                width: '1/4',
                height: '1/3'
            },
            id: "5",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/4',
                top: '1/3',
                width: '1/4',
                height: '1/3'
            },
            id: "6",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/2',
                top: '1/3',
                width: '1/4',
                height: '1/3'
            },
            id: "7",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '1/3',
                width: '1/4',
                height: '1/3'
            },
            id: "8",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '2/3',
                width: '1/4',
                height: '1/3'
            },
            id: "9",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/4',
                top: '2/3',
                width: '1/4',
                height: '1/3'
            },
            id: "10",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/2',
                top: '2/3',
                width: '1/4',
                height: '1/3'
            },
            id: "11",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '2/3',
                width: '1/4',
                height: '1/3'
            },
            id: "12",
            shape: "rectangle"
        }
    }],
    13:[
        {

        region: {
            area: {
                left: '0',
                top: '0',
                width: '1/4',
                height: '1/4'
            },
            id: "2",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/4',
                top: '0',
                width: '1/4',
                height: '1/4'
            },
            id: "3",
            shape: "rectangle"
        }
    },{


        region: {
            area: {
                left: '1/2',
                top: '0',
                width: '1/4',
                height: '1/4'
            },
            id: "4",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '0',
                width: '1/4',
                height: '1/4'
            },
            id: "5",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '1/4',
                width: '1/4',
                height: '1/4'
            },
            id: "6",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/4',
                top: '1/4',
                width: '1/2',
                height: '1/2'
            },
            id: "1",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '1/4',
                width: '1/4',
                height: '1/4'
            },
            id: "7",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '1/2',
                width: '1/4',
                height: '1/4'
            },
            id: "8",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '1/2',
                width: '1/4',
                height: '1/4'
            },
            id: "9",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '0',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "10",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/4',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "11",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/2',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "12",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "13",
            shape: "rectangle"
        }
    }],
    14:[
        {

        region: {
            area: {
                left: '1/8',
                top: '0',
                width: '1/4',
                height: '1/4'
            },
            id: "1",
            shape: "rectangle"
        }
    },
        {

        region: {
            area: {
                left: '3/8',
                top: '0',
                width: '1/4',
                height: '1/4'
            },
            id: "2",
            shape: "rectangle"
        }
    },
        {

        region: {
            area: {
                left: '5/8',
                top: '0',
                width: '1/4',
                height: '1/4'
            },
            id: "3",
            shape: "rectangle"
        }
    },
        {

        region: {
            area: {
                left: '1/8',
                top: '1/4',
                width: '1/4',
                height: '1/4'
            },
            id: "4",
            shape: "rectangle"
        }
    },
        {

        region: {
            area: {
                left: '3/8',
                top: '1/4',
                width: '1/4',
                height: '1/4'
            },
            id: "5",
            shape: "rectangle"
        }
    },
        {

        region: {
            area: {
                left: '5/8',
                top: '1/4',
                width: '1/4',
                height: '1/4'
            },
            id: "6",
            shape: "rectangle"
        }
    },
        {

        region: {
            area: {
                left: '0',
                top: '1/2',
                width: '1/4',
                height: '1/4'
            },
            id: "7",
            shape: "rectangle"
        }
    },
        {

        region: {
            area: {
                left: '1/4',
                top: '1/2',
                width: '1/4',
                height: '1/4'
            },
            id: "8",
            shape: "rectangle"
        }
    },
        {

        region: {
            area: {
                left: '1/2',
                top: '1/2',
                width: '1/4',
                height: '1/4'
            },
            id: "9",
            shape: "rectangle"
        }
    },
        {

            region: {
                area: {
                    left: '3/4',
                    top: '1/2',
                    width: '1/4',
                    height: '1/4'
                },
                id: "10",
                shape: "rectangle"
            }
        },
        {

        region: {
            area: {
                left: '0',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "11",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/4',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "12",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '1/2',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "13",
            shape: "rectangle"
        }
    },{

        region: {
            area: {
                left: '3/4',
                top: '3/4',
                width: '1/4',
                height: '1/4'
            },
            id: "14",
            shape: "rectangle"
        }
    }],
    15:[
        {

        region: {
            area: {
                left: '1/8',
                top: '0',
                width: '1/4',
                height: '1/4'
            },
            id: "1",
            shape: "rectangle"
        }
    },
        {

            region: {
                area: {
                    left: '3/8',
                    top: '0',
                    width: '1/4',
                    height: '1/4'
                },
                id: "2",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '5/8',
                    top: '0',
                    width: '1/4',
                    height: '1/4'
                },
                id: "3",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '0',
                    top: '1/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "4",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '1/4',
                    top: '1/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "5",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '1/2',
                    top: '1/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "6",
                shape: "rectangle"
            }
        },{

            region: {
                area: {
                    left: '3/4',
                    top: '1/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "7",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '0',
                    top: '1/2',
                    width: '1/4',
                    height: '1/4'
                },
                id: "8",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '1/4',
                    top: '1/2',
                    width: '1/4',
                    height: '1/4'
                },
                id: "9",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '1/2',
                    top: '1/2',
                    width: '1/4',
                    height: '1/4'
                },
                id: "10",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '3/4',
                    top: '1/2',
                    width: '1/4',
                    height: '1/4'
                },
                id: "11",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '0',
                    top: '3/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "12",
                shape: "rectangle"
            }
        },{

            region: {
                area: {
                    left: '1/4',
                    top: '3/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "13",
                shape: "rectangle"
            }
        },{

            region: {
                area: {
                    left: '1/2',
                    top: '3/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "14",
                shape: "rectangle"
            }
        },{

            region: {
                area: {
                    left: '3/4',
                    top: '3/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "15",
                shape: "rectangle"
            }
        }],
    16:[
        {

            region: {
                area: {
                    left: '0',
                    top: '0',
                    width: '1/4',
                    height: '1/4'
                },
                id: "1",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '1/4',
                    top: '0',
                    width: '1/4',
                    height: '1/4'
                },
                id: "2",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '1/2',
                    top: '0',
                    width: '1/4',
                    height: '1/4'
                },
                id: "3",
                shape: "rectangle"
            }
        }, {

            region: {
                area: {
                    left: '3/4',
                    top: '0',
                    width: '1/4',
                    height: '1/4'
                },
                id: "4",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '0',
                    top: '1/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "5",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '1/4',
                    top: '1/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "6",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '1/2',
                    top: '1/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "7",
                shape: "rectangle"
            }
        },{

            region: {
                area: {
                    left: '3/4',
                    top: '1/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "8",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '0',
                    top: '1/2',
                    width: '1/4',
                    height: '1/4'
                },
                id: "9",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '1/4',
                    top: '1/2',
                    width: '1/4',
                    height: '1/4'
                },
                id: "10",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '1/2',
                    top: '1/2',
                    width: '1/4',
                    height: '1/4'
                },
                id: "11",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '3/4',
                    top: '1/2',
                    width: '1/4',
                    height: '1/4'
                },
                id: "12",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '0',
                    top: '3/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "13",
                shape: "rectangle"
            }
        },{

            region: {
                area: {
                    left: '1/4',
                    top: '3/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "14",
                shape: "rectangle"
            }
        },{

            region: {
                area: {
                    left: '1/2',
                    top: '3/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "15",
                shape: "rectangle"
            }
        },{

            region: {
                area: {
                    left: '3/4',
                    top: '3/4',
                    width: '1/4',
                    height: '1/4'
                },
                id: "16",
                shape: "rectangle"
            }
        }
    ],
    17:[
         {

            region: {
                area: {
                    left: '0',
                    top: '3/28',
                    width: '1/2',
                    height: '1/2'
                },
                id: "1",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '1/2',
                    top: '3/28',
                    width: '1/2',
                    height: '1/2'
                },
                id: "2",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '0',
                    top: '17/28',
                    width: '1/7',
                    height: '1/7'
                },
                id: "3",
                shape: "rectangle"
            }
        }, {

            region: {
                area: {
                    left: '1/7',
                    top: '17/28',
                    width: '1/7',
                    height: '1/7'
                },
                id: "4",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '2/7',
                    top: '17/28',
                    width: '1/7',
                    height: '1/7'
                },
                id: "5",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '3/7',
                    top: '17/28',
                    width: '1/7',
                    height: '1/7'
                },
                id: "6",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '4/7',
                    top: '17/28',
                    width: '1/7',
                    height: '1/7'
                },
                id: "7",
                shape: "rectangle"
            }
        },{

            region: {
                area: {
                    left: '5/7',
                    top: '17/28',
                    width: '1/7',
                    height: '1/7'
                },
                id: "8",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '6/7',
                    top: '17/28',
                    width: '1/7',
                    height: '1/7'
                },
                id: "9",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '0',
                    top: '21/28',
                    width: '1/7',
                    height: '1/7'
                },
                id: "10",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '1/7',
                    top: '21/28',
                    width: '1/7',
                    height: '1/7'
                },
                id: "11",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '2/7',
                    top: '21/28',
                    width: '1/7',
                    height: '1/7'
                },
                id: "12",
                shape: "rectangle"
            }
        },
        {

            region: {
                area: {
                    left: '3/7',
                    top: '21/28',
                    width: '1/7',
                    height: '1/7'
                },
                id: "13",
                shape: "rectangle"
            }
        },{

            region: {
                area: {
                    left: '4/7',
                    top: '21/28',
                    width: '1/7',
                    height: '1/7'
                },
                id: "14",
                shape: "rectangle"
            }
        },{

            region: {
                area: {
                    left: '5/7',
                    top: '21/28',
                    width: '1/7',
                    height: '1/7'
                },
                id: "15",
                shape: "rectangle"
            }
        },{

            region: {
                area: {
                    left: '6/7',
                    top: '21/28',
                    width: '1/7',
                    height: '1/7'
                },
                id: "16",
                shape: "rectangle"
            }
        }
    ]
}
